exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c_follow{margin-bottom:2rem}.c_follow.fixed-bottom{position:fixed;bottom:0;left:0;right:0;background:#fff;padding:1rem;-webkit-box-shadow:0 -2px 10px rgba(0,0,0,.1);box-shadow:0 -2px 10px rgba(0,0,0,.1);margin-bottom:0;z-index:1000}.share-button{background:tomato;color:#fff;font-size:1.15em;border-radius:4px;height:40px;min-height:40px;max-height:40px;max-width:750px;position:relative;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;border:none;vertical-align:top;cursor:pointer;overflow:hidden}.share-div{margin:auto;text-align:center}@media (min-width:60em){.share-div{display:none;width:33%}}", ""]);

// exports
